// extracted by mini-css-extract-plugin
module.exports = {"container":"PageLoading-module--container--3QSyy","loading":"PageLoading-module--loading--3G620"};